// extracted by mini-css-extract-plugin
export default {"Footer-logo":"Footer_Footer-logo__TpKdM"};